import { Link, useLocation } from 'react-router-dom';
import AuthShell from '../../components/auth/AuthShell';

function wasDeleted(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { deleted?: unknown }).deleted === true
  );
}

export default function SignedOut() {
  const location = useLocation();
  if (wasDeleted(location.state)) {
    return (
      <AuthShell
        title="Account deleted"
        subtitle="Your OculusMind.AI account and credentials have been removed."
      >
        <p>
          We're sorry to see you go. You can{' '}
          <Link to="/auth/signup">create a new account</Link> or return{' '}
          <Link to="/">home</Link>.
        </p>
      </AuthShell>
    );
  }
  return (
    <AuthShell title="Signed out" subtitle="Your session has ended.">
      <p>
        <Link to="/auth/signin">Sign in again</Link> or return{' '}
        <Link to="/">home</Link>.
      </p>
    </AuthShell>
  );
}
